export const companyInsights = {
  items: [
    {
      id: '30650cd2-994c-40da-aa34-5408a7a15479',
      insight: {
        id: 'ce92e13c-41f9-43c4-b1e1-57821c4e57d1',
        title: 'Ризик падіння мотивації',
        content: `**Проблема:**
-------------

Відсутність командної мотивації є проблемою для співробітників, оскільки це часто призводить до зниження співпраці та спілкування, важливих компонентів успішних командних проектів. Без мотивації співробітникам може бути важко знайти мету та задоволення від своєї роботи, що може призвести до зниження продуктивності та креативності. Відсутність ентузіазму часто призводить до стагнації робочого середовища, де інновації пригнічуються, а можливості для зростання та розвитку втрачаються. Крім того, демотивована команда може створити негативну атмосферу, впливаючи на індивідуальний моральний стан і призводячи до загального погіршення благополуччя на робочому місці.

### Як це впливає на бізнес

*   це часто призводить до зниження продуктивності, оскільки демотивовані працівники менш схильні докладати зусиль і відданості, необхідних для високої продуктивності. Це може безпосередньо вплинути на прибутки компанії;
*   це може перешкоджати інноваціям і креативності, які необхідні для того, щоб бізнес адаптувався, розвивався та залишався конкурентоспроможним на ринку;
*   коли працівники не мотивовані, якість обслуговування клієнтів може постраждати, що потенційно може призвести до втрати клієнтів і шкоди репутації компанії;
*   низький рівень мотивації в команді може сприяти вищій плинності кадрів, спричиняючи додаткові витрати на наймання та навчання, порушуючи послідовність і згуртованість командної динаміки.

### Опис послуги

Важливо розуміти, що в таких випадках мотивація тісно пов’язана з особистими переконаннями та цінностями працівника. Завдання полягає у виявленні, аналізі та виправленні деструктивних переконань для підвищення рівня мотивації співробітників і систематизації трудових цінностей з акцентом на підвищення продуктивності співробітників.

### Покрокове рішення

*   **Поглиблений скринінг особистості та профілювання:** поглиблений аналіз та оцінка характеристик особистості, вивчення моделей поведінки, особливостей спілкування, мотиваційних факторів, а також емоційних і когнітивних рис особистості.
*   **Групова та індивідуальна психотерапія:** є центральним елементом ефективної роботи з командою та співробітниками індивідуально, розробляється за результатами тестування та передбачає індивідуально підібрану кількість годин.
*   **Психологічні лекції:** спрямовані на посилення мотивації співробітників шляхом використання науково перевірених психологічних стратегій і технік для підвищення продуктивності та покращення командної роботи.

#### Приклади лекцій

*   «Психологія мотивації - як зрозуміти внутрішні стимули»
*   «Цілепокладання та досягнення: навички правильної постановки цілей»
*   «Особливості групової мотивації»
*   «Самомотивація на роботі: застосування когнітивно-поведінкових технік»

_Кількість лекцій визначається індивідуально._

### Які показники ми збільшимо за допомогою цього рішення

*   Продуктивність співробітників: покращена мотивація зазвичай призводить до підвищення продуктивності, оскільки мотивовані співробітники, швидше за все, працюватимуть ефективно та результативно.
*   Якість роботи: з підвищеною мотивацією якість результату часто покращується, оскільки працівники більше пишаються своєю роботою та зацікавлені нею.
*   Рівень утримання співробітників: рішення, які ефективно вирішують проблеми мотивації, можуть призвести до збільшення утримання співробітників, оскільки задоволені та мотивовані працівники з меншою ймовірністю шукатимуть роботу в іншому місці.
*   Показники залученості співробітників: рішення, спрямовані на підвищення мотивації, швидше за все, відобразяться на вищих показниках залученості співробітників, що вказує на більш віддану та задоволену робочу силу.
*   Інновації та креативність: вмотивовані співробітники з більшою ймовірністю внесуть інноваційні ідеї та креативні рішення, сприяючи зростанню компанії та конкурентній перевазі.
*   Задоволеність клієнтів: мотивовані співробітники зазвичай надають краще обслуговування клієнтів, що призводить до підвищення задоволеності та лояльності клієнтів.
*   Зменшення прогулів: вищий рівень мотивації може зменшити рівень прогулів, оскільки працівники більш віддані справі та рідше беруть непотрібні відпустки.
*   Згуртованість і співпраця в команді: посилена мотивація може покращити командну роботу та співпрацю, що призведе до більш ефективної командної динаміки та результатів проекту.


`,
        imageCover:
          'https://images.unsplash.com/photo-1486312338219-ce68d2c6f44d?q=80&w=3544&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
        isActive: true,
        version: 1,
        createdAt: '2023-01-01T00:00:00Z',
        updatedAt: '2023-01-02T00:00:00Z',
      },
      teams: [
        {
          id: 'e9efa9b8-1f03-4ba2-a1b6-eb3e9d4e7cbf',
          teamName: 'Team Revenue',
        },
        {
          id: '43d49e32-b6fc-453c-b311-3ff4b4cc0fbf',
          teamName: 'SEO Team',
        },
        {
          id: 'e340cbb3-b89f-4fc4-82d4-0c183d915dae',
          teamName: 'Growth Team',
        },
        {
          id: 'db5d4c68-2b24-4b44-85ca-260e116c7b55',
          teamName: 'UX Team',
        },
        {
          id: '95359c78-b071-49e0-970d-3e1a2d6106d5',
          teamName: 'Content Team',
        },
      ],
      status: 'new',
      quota: 30,
      createdAt: '2023-01-01T00:00:00Z',
      updatedAt: '2023-01-02T00:00:00Z',
    },
    {
      id: '30650cd2-994c-40da-aa34-5408a7a15456',
      insight: {
        id: 'ce92e13c-41f9-43c4-b1e1-57821c4e57d1',
        title: ' Ризик падіння ефективності',
        content: `**Проблема:**
-------------

Недостатнє усвідомлення здібностей і потенціалу співробітника є значною
проблемою, оскільки це часто призводить до неефективності та нереалізованого
кар’єрного росту. Співробітники можуть вагатися, чи братимуться за нові завдання чи
керівні ролі, що обмежує їх професійний розвиток і внесок в організацію. Відсутність
самосвідомості може призвести до втрати можливостей як для особистого розвитку, так і
для цінного внеску в командні проекти. Більше того, це може призвести до зниження
задоволеності роботою та відчуття застою, оскільки працівники не в змозі розпізнати та
повністю використати свій потенціал у своїх ролях.

* * *

**Як це впливає на бізнес**
---------------------------

*   це призводить до недостатнього використання талантів, коли навички та здібності
працівників не використовуються повністю, що призводить до втрати інновацій та
креативності;
*  це може створити невідповідність між ролями працівників та їхніми навичками, що
призводить до неефективності та зниження продуктивності;
*   коли працівники не розуміють свого потенціалу, вони менш схильні проявляти
ініціативу або прагнути до просування, що призводить до застою робочої сили та
культури, яка не сприяє зростанню чи вдосконаленню;
*   недостатня обізнаність може сприяти зниженню морального духу співробітників і
задоволеності роботою, оскільки люди відчувають себе недооціненими, що
потенційно збільшує рівень плинності кадрів.

* * *

**Опис послуги**
----------------

Завдання полягає в тому, щоб виправити проблеми співробітників, такі як страх
відповідальності, перфекціонізм, страх успіху, великих грошей. Програма допомагає
власникам бізнесу мінімізувати ризики неефективних інвестицій у ключових
співробітників.

* * *

### Покрокове рішення

*   **Поглиблений скринінг особистості та соціометрія:** необхідні для оцінки особистісних якостей членів команди, аналізу взаємодій та загального стану групової динаміки, моделей міжособистісних зв’язків у команді, виявлення позитивних та негативних елементів у стосунках та структурі команди. [https://effiz.io/](https://effiz.io/)
*   **Дослідити професійну спрямованість типу менеджерів** та їх ключові компетенції, визначити найбільш і найменш розвинені професійні вміння та навички.
*   **Групова та індивідуальна психотерапія:** структура зустрічей створюється на основі інформації, отриманої під час скринінгу, і спрямована на планомірне підвищення рівня компетенцій та стійкості, а також передбачає проведення до 5 індивідуальних сесій з ключовими співробітниками компанії.
*   **Психологічні лекції:** спрямовані на розвиток навичок об'єктивного сприйняття здібностей, потенціалу співробітників, стратегії його підвищення. Співробітники на керівних посадах навчилися швидко аналізувати потенціал співробітників і розуміти основні показники, на які варто звернути увагу.

#### Приклади лекцій:

*   «Розвиток особистісного потенціалу»
*   «Розвиток професійних компетенцій»
*   «Ефективність праці: теорія і практика»
*   «Оптимізація управлінського потенціалу: психологічні підходи до лідерства»

**Які показники ми збільшимо за допомогою цього рішення**
---------------------------------------------------------

*   **Продуктивність співробітників:** розподіляючи співробітників на ролі, які
відповідають їхнім навичкам і потенціалу, продуктивність підвищиться завдяки
підвищенню ефективності роботи.
*   **Залученість і задоволеність працівників:** розуміння та використання здібностей
працівників може призвести до більшої задоволеності роботою та залученості,
оскільки працівники відчувають, що їх цінують і ефективно використовують їх
здібності.
*   **Утримання талантів:** рішення, які визнають і розвивають потенціал співробітників,
сприяють зниженню плинності кадрів, оскільки співробітники, швидше за все,
залишаться на робочому місці, де визнають їхні внески та підтримують їх розвиток.
*   **Інновації та креативність:** коли співробітники розуміють свій потенціал і їх
заохочують використовувати на повну силу, інновації та креативність в організації
зазвичай зростають
*   **Якість роботи:** покращене узгодження навичок і ролей може призвести до вищої
якості роботи, оскільки працівники більш компетентні та впевнені у своїх
обов’язках.
*   **Професійний розвиток:** показники, пов’язані з розвитком співробітників і
просуванням по службі, ймовірно, покращаться, оскільки співробітникам нададуть
можливість реалізувати та розширити свій потенціал.
*   **Ефективність команди:** покращене розуміння можливостей кожного члена команди
може призвести до ефективнішої командної співпраці та результатів роботи`,
        imageCover:
          'https://images.unsplash.com/photo-1698077689052-73daf0d5b10b?q=80&w=2688&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
        isActive: true,
        version: 1,
        createdAt: '2023-01-01T00:00:00Z',
        updatedAt: '2023-01-02T00:00:00Z',
      },
      teams: [
        {
          id: 'db5d4c68-2b24-4b44-85ca-260e116c7b55',
          teamName: 'UX Team',
        },
        {
          id: '95359c78-b071-49e0-970d-3e1a2d6106d5',
          teamName: 'Content Team',
        },
        {
          id: 'e9efa9b8-1f03-4ba2-a1b6-eb3e9d4e7cbf',
          teamName: 'Team Revenue',
        },
        {
          id: '48adc647-ff9c-43d5-a3ab-b152ecf19d9d',
          teamName: 'Team CRM',
        },
        {
          id: '3fef45e1-24c3-4e0c-8453-5a189a3efe4e',
          teamName: 'Frontend Team',
        },
      ],
      status: 'paid',
      quota: 80,
      createdAt: '2023-01-01T00:00:00Z',
      updatedAt: '2023-01-02T00:00:00Z',
    },
    {
      id: '30650cd2-994c-40da-aa34-5408a7a15431',
      insight: {
        id: 'ce92e13c-41f9-43c4-b1e1-57821c4e57d1',
        title: 'Ризик конфліктів у команді',
        content: `**Проблема**
------------

Відсутність навичок спілкування є серйозною проблемою для працівників, оскільки
це може призвести до непорозумінь, неправильного тлумачення та ескалації напруги на
робочому місці. Погана комунікація часто призводить до неефективної командної роботи,
коли життєво важлива інформація або не передається, або передається неточно, що
впливає на результати проекту та процеси прийняття рішень. Крім того, нездатність
ефективно вирішувати конфлікти може призвести до токсичного робочого середовища,
зниження морального духу та збільшення стресу серед членів команди. Цей недолік не
тільки перешкоджає індивідуальній продуктивності, але й підриває загальний стан і
продуктивність організаційної культури.

### Як це впливає на бізнес

*  Погана комунікація часто призводить до неузгодженості цілей і непорозумінь, що
призводить до неефективності та помилок у робочих процесах;
*   Це може вплинути на часові рамки проекту, якість результату та задоволеність
клієнтів;
*   Нездатність розв’язувати конфлікти може перерости в деструктивні проблеми на
робочому місці, завдаючи шкоди моральному духу команди та співпраці;
*   Таке середовище пригнічує інновації та креативність, оскільки працівники можуть
вагатися ділитися ідеями чи брати участь у змістовних дискусіях;
*   Постійні конфлікти та комунікаційні бар’єри можуть сприяти високій плинності
кадрів, оскільки працівники прагнуть до більш гармонійного робочого середовища

### Опис послуги

Завдання – посередництво та вдосконалення навичок соціальної взаємодії та
спілкування. Програма включає допомогу у вирішенні корпоративних конфліктів та
супровід, спрямований на прискорення процесу примирення та відновлення ефективної
роботи команди.

### Покрокове рішення

1.  **Поглиблений скринінг особистості та соціометрія:** спрямований на аналіз
індивідуальних особливостей членів команди та групової динаміки, вивчення
моделей міжособистісних стосунків, виявлення як конструктивних, так і 
деструктивних стосунків. Оцінка конфліктних зон в команді, вивчення рівня
конфліктності учасників, виявлення стилів поведінки ключових співробітників,
виявлення можливих проблем співробітників з комунікативними навичками.
2.  **Групова та індивідуальна психотерапія:** програма складається за результатами
попереднього скринінгу та включає плановий графік, що передбачає поступове
підвищення рівня сформованих навичок та вирішення психологічних питань з
індивідуально підібраною кількістю годин.
3.  **Психологічні лекції:** спрямовані на покращення взаєморозуміння між
співробітниками та підвищення загальної ефективності команди. Вони
допомагають знизити рівень напруги в колективі, навчаючи співробітників
ефективним методам діалогу та вмінню знаходити конструктивні рішення в
конфліктних ситуаціях.

#### Приклади лекцій

*   «Методи міжособистісного спілкування та вирішення конфліктів»
*   «Психологія ефективного спілкування та управління конфліктами»
*   «Аналіз механізмів і стратегій вирішення конфліктів»
*   «Лідерство, комунікація та управління конфліктами в організаціях»


### Які показники ми збільшимо за допомогою цього рішення

*   **Залученість і задоволеність співробітників:** ефективне спілкування і вирішення
конфліктів може призвести до підвищення рівня залученості співробітників і
задоволеності роботою, оскільки співробітники відчувають, що їх чують і цінують
у середовищі співпраці
*   **Продуктивність команди:** покращені комунікативні навички та ефективне
вирішення конфліктів сприяють підвищенню продуктивності команди, оскільки
завдання виконуються ефективніше завдяки чіткій та злагодженій співпраці.
*   **Рівень завершеності проектів:** краща комунікація та управління конфліктами
можуть оптимізувати робочі процеси команди, сприяючи своєчасному завершенню
проектів і більш узгодженому дотриманню встановлених термінів.
*   **Рівень утримання співробітників:** робоче середовище з сильними навичками
спілкування та вирішення конфліктів є більш сприятливим для утримання
співробітників, оскільки воно сприяє створенню позитивної та сприятливої
культури на робочому місці
*   **Інновації та креативність:** відкриті та ефективні канали зв’язку заохочують
інновації та креативність, оскільки працівники відчувають себе комфортніше
обмінюватися ідеями та співпрацювати над рішеннями.
*   **Задоволеність клієнтів:** покращення внутрішньої комунікації часто призводить до
кращого обслуговування клієнтів і взаємодії з клієнтами, підвищення задоволеності
та лояльності клієнтів.
*   **Зменшення конфліктів на робочому місці:** за допомогою ефективних стратегій
вирішення конфліктів можна значно зменшити частоту та інтенсивність конфліктів
на робочому місці, створюючи більш гармонійне робоче середовище.
*   **Якість прийняття рішень:** покращені комунікативні навички сприяють кращому
процесу прийняття рішень, оскільки різноманітні точки зору ефективно
обмінюються та розглядаються.`,
        imageCover:
          'https://images.unsplash.com/photo-1653669487221-252f32c53f2c?q=80&w=3540&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',

        isActive: true,
        version: 1,
        createdAt: '2023-01-01T00:00:00Z',
        updatedAt: '2023-01-02T00:00:00Z',
      },
      teams: [
        {
          id: '524c6982-5218-40dd-8334-8b9ddd5009f2',
          teamName: 'Social Media Team',
        },
        {
          id: 'c3024e07-a5b8-4cc4-be89-8c5b66d86f57',
          teamName: 'Backend Team',
        },
        {
          id: 'd273b9c9-5476-4b9b-a0b5-00e0524c2a26',
          teamName: 'DevOps Team',
        },
        {
          id: '1e80c7d7-a286-4610-8aac-0b7483cd97e5',
          teamName: 'Team Outreach',
        },
        {
          id: '43d49e32-b6fc-453c-b311-3ff4b4cc0fbf',
          teamName: 'SEO Team',
        },
        {
          id: 'e340cbb3-b89f-4fc4-82d4-0c183d915dae',
          teamName: 'Growth Team',
        },
      ],
      status: 'postponed',
      quota: 100,
      createdAt: '2023-01-01T00:00:00Z',
      updatedAt: '2023-01-02T00:00:00Z',
    },
    {
      id: '30650cd2-994c-40da-aa34-5408a7a11279',
      insight: {
        id: 'ce92e13c-41f9-43c4-b1e1-57821c4e57d1',
        title: 'Ризик вигорання',
        content: `**Проблема**
---------------------------------------
Професійне вигорання є серйозною проблемою для співробітників, оскільки
призводить до різкого зниження продуктивності та залученості до роботи. Це часто
призводить до збільшення прогулів і вищої плинності кадрів, оскільки працівники
відчувають себе занадто перевантаженими або відстороненими, щоб працювати
ефективно. Вигорання також може сприяти виникненню різноманітних проблем з
психічним і фізичним здоров’ям, ще більше впливаючи на працездатність працівника та
загальну якість його життя. Крім того, це може негативно вплинути на моральний стан на
робочому місці та створити напружене середовище не лише для особи, яка страждає від
цього, але й для колег.
### Як це впливає на бізнес

*   це часто призводить до зниження продуктивності, оскільки працівники, які
борються з виснаженням, зазвичай менш зосереджені, менш ефективні та менш
мотивовані;
*   якість роботи страждає, оскільки виснаження може призвести до відсутності
креативності, неправильного прийняття рішень і більшої кількості помилок;
*   професійне вигорання сприяє вищій плинності кадрів, що не тільки спричиняє
додаткові витрати на наймання та навчання нових працівників, але й може
порушити динаміку та безперервність команди;
*   культура, де панує виснаження, може завдати шкоди репутації компанії,
ускладнивши залучення найкращих талантів і потенційно вплинути на відносини з
клієнтами.

### Опис послуги

Головне завдання – навчити співробітників розпізнавати та розрізняти ознаки
професійного вигорання, втому та негативні емоції, зменшити негативний вплив
вигорання на особистість та колектив. Це включає в себе розвиток навичок управління
емоціями за допомогою ефективних стратегій для підтримки психологічного здоров'я та
благополуччя в професійному середовищі.
### Покрокове рішення

*   **Поглиблений скринінг особистості та соціометрія:** необхідні для всебічного
розуміння індивідуальних якостей особистості кожного члена команди, аналізу
групової динаміки та стосунків у колективі за допомогою соціометричного методу
для виявлення симпатій, антипатій та емоційних взаємодій, виявлення позитивних
та негативних елементів і зв'язків у колективі, дослідження рівня емоційної
компетентності співробітників та їх здатності до емоційного реагування. Необхідна
комплексна оцінка емоційної компетентності співробітників.
*   **Групова та індивідуальна психотерапія:** кількість зустрічей розробляється за
результатами скринінгу і включає мінімум 6 індивідуальних занять з ключовими
співробітниками компанії, а також кілька групових тренінгів з навичок регуляції
емоцій.
*   **Психологічні лекції:** спрямовані на психоосвіту в області емоційного реагування,
управління стресом і розробки ефективних психологічних стратегій подолання.

#### Приклади лекцій:

*   «Профілактика професійного вигорання: інтегративний підхід»
*   «Нейробіологічні аспекти професійного вигорання»
*   «Вплив організаційної культури на рівень вигорання співробітників»
*   «Розвиток емоційного інтелекту та саморегуляції»

### Які показники ми збільшимо за допомогою цього рішення

*   **Продуктивність співробітників:** якщо вирішити проблему вигорання,
співробітники, ймовірно, стануть більш залученими та ефективними, що призведе
до підвищення рівня продуктивності.
*   **Коефіцієнт утримання співробітників:** Ефективні рішення щодо вигорання можуть
зменшити плинність кадрів за рахунок збільшення задоволеності роботою та
лояльності співробітників, тим самим утримуючи кваліфікований персонал.
*   **Якість роботи:** у міру зменшення виснаження якість роботи зазвичай покращується
завдяки підвищенню концентрації, креативності та мотивації серед працівників.
*   **Оцінки залученості співробітників:** вирішення проблеми вигорання часто
призводять до більшої залученості співробітників, як вимірюється опитуваннями та
механізмами зворотного зв’язку.
*   **Зменшення кількості прогулів:** Успішна боротьба з виснаженням може призвести до
зменшення кількості втрачених днів через відсутність, пов’язану зі стресом, таким
чином покращуючи показники відвідуваності.
*   **Витрати на охорону здоров’я:** Запобігаючи вигоранню та вирішуючи питання про
вигорання, організація може побачити зменшення витрат на охорону здоров’я та
страхування, пов’язаних зі стресом і проблемами психічного здоров’я.
*   **Показники благополуччя працівників:** загальні показники благополуччя,
включаючи показники психічного та фізичного здоров’я, ймовірно, покращаться,
демонструючи здоровішу робочу силу.
*   **Задоволеність клієнтів:** опосередковано зменшення вигоряння може призвести до
кращої взаємодії з клієнтами та більшої задоволеності клієнтів, оскільки
співробітники більш позитивні та уважні.
`,
        imageCover:
          'https://images.unsplash.com/photo-1517898717281-8e4385a41802?q=80&w=3538&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
        isActive: true,
        version: 1,
        createdAt: '2023-01-01T00:00:00Z',
        updatedAt: '2023-01-02T00:00:00Z',
      },
      teams: [
        {
          id: '1e80c7d7-a286-4610-8aac-0b7483cd97e5',
          teamName: 'Team Outreach',
        },
        {
          id: '48adc647-ff9c-43d5-a3ab-b152ecf19d9d',
          teamName: 'Team CRM',
        },
        {
          id: '3fef45e1-24c3-4e0c-8453-5a189a3efe4e',
          teamName: 'Frontend Team',
        },
        {
          id: 'd273b9c9-5476-4b9b-a0b5-00e0524c2a26',
          teamName: 'DevOps Team',
        },
        {
          id: 'c3024e07-a5b8-4cc4-be89-8c5b66d86f57',
          teamName: 'Backend Team',
        },
      ],
      status: 'new',
      quota: 60,
      createdAt: '2023-01-01T00:00:00Z',
      updatedAt: '2023-01-02T00:00:00Z',
    },
  ],
  meta: {
    page: 1,
    limit: 10,
    total: 4,
    totalPages: 1,
  },
};
